<template>
    <div>
        <forms
                :settings="settings"
                @onFormButtonClick="onFormButtonClick"
                @onInput="onInput"
        >
        </forms>
    </div>
</template>

<script>
import axios from "axios";
import toastr from 'toastr';
import Forms from "@/components/form/Forms";
export default {
    name: "SkupKotizacijaForma",
    components: { Forms },
    props:{
        disabled:{
            type: Boolean,
            default: false
        },
        id:{
            default: null
        },
        modal:{
            type: Boolean,
            default: false
        },
        action: {
            type: String
        }
    },
    data(){
        return {
            settings: {},
            errors: {},
            route: '/skupovi/' + this.$route.params.skup_id + '/kotizacije',
            url: 'skup-kotizacija',
            data: {},
            skup: {},
            skup_id: this.$route.params.skup_id,

            vrsta_sudionika_select: [],
            kotizacije_select: [],
            porezi_select: []
        }
    },

    methods: {

        async fetchSkup(){
            let vm = this
            await axios.get( process.env.VUE_APP_API_URL + 'skup' + '/' + this.skup_id )
                .then( response => vm.skup = response.data )
                .catch( error => console.log( error ) )
        },

        async fetchVrsteSudionika(){
            let vm = this
            const response = await axios.get(process.env.VUE_APP_API_URL + 'vrsta-sudionika', {
                params: {
                    filters: {
                        izzy_edu_vrsta_sudionika: vm.skup.izzy_edu_id
                    }
                }
            } )
            return response.data.data.map( function( item ) {
                vm.vrsta_sudionika_select.push(
                    {
                        key: item.id.toString(),
                        value: item.naziv
                    }
                )
            } )
        },

        getVrstaSudionika( id ){
            return this.vrsta_sudionika_select.find( item => item.key === id )
        },

        async fetchKotizacije(){
            let vm = this
            const response = await axios.get(process.env.VUE_APP_API_URL + 'kotizacija' )
            return response.data.data.map( function( item ) {
                vm.kotizacije_select.push(
                    {
                        key: item.id.toString(),
                        value: item.naziv + ' | ' + item.vrste_kotizacija.naziv
                    }
                )
            } )
        },

        getKotizacija( id ){
            return this.kotizacije_select.find( item => item.key === id )
        },

        async fetchPorezi(){
            let vm = this
            const response = await axios.get(process.env.VUE_APP_API_URL + 'porez' )
            return response.data.data.map( function( item ) {
                vm.porezi_select.push(
                    {
                        key: item.id.toString(),
                        value: item.postotak
                    }
                )
            } )
        },

        getPorez( id ){
            return this.porezi_select.find( item => item.key === id )
        },

        async init(){
            let vm = this

            await vm.fetchSkup()
            await vm.fetchVrsteSudionika()
            await vm.fetchKotizacije()
            await vm.fetchPorezi()

            if ( vm.action === 'edit' || vm.action === 'show' ){

                axios.get( process.env.VUE_APP_API_URL + vm.url + '/' + vm.id )
                        .then( function ( response ) {
                            console.log( response.data )
                            vm.data.vrsta_sudionika_id = response.data.vrsta_sudionika_id ? response.data.vrsta_sudionika_id.toString() : ''
                            vm.data.kotizacija_id = response.data.kotizacija_id ? response.data.kotizacija_id.toString() : ''
                            vm.data.cijena = response.data.cijena
                            vm.data.porez_id = response.data.porez_id ? response.data.porez_id.toString() : ''

                            vm.$emit( 'returnData', response.data )
                            vm.setupForm()
                        } )
                        .catch( function ( error ) {
                            if(error instanceof Error) {
                                console.log( 'Error: ' . error);
                            } else {
                                console.log( 'Unexpected response: ' . error);
                            }
                        } )

            } else if ( vm.action === 'create' ) {
                vm.data = {}
                vm.setupForm()
            } else {
                return
            }
        },

        setupForm(){

            let vm = this;

            vm.buttons = []

            let button_cancel = {
                id: 'cancel',
                title: 'Odustani',
                type: 'warning',
                action: 'redirect', // request
                config: {
                    url: vm.route + ( vm.action === 'edit' ? ( '/' + vm.id) : '' )
                }
            }

            let button_delete = {
                id: 'delete',
                title: 'Obriši',
                type: 'danger',
                action: 'request',
                config: {
                    method: 'DELETE',
                    url: process.env.VUE_APP_API_URL + vm.url + '/' + vm.id
                }
            }

            let button_edit = {
                id: 'edit',
                title: 'Uredi',
                type: 'success',
                action: 'redirect',
                config: {
                    url: vm.route +  '/' + vm.id +'/edit'
                }
            }

            let button_save = {
                id: 'save',
                title: 'Spremi',
                type: 'primary',
                action: 'request',
                config: {
                    method: 'POST',
                    url: process.env.VUE_APP_API_URL + vm.url
                }
            }

            let button_update = {
                id: 'update',
                title: 'Spremi',
                type: 'primary',
                action: 'request',
                config: {
                    method: 'PUT',
                    url: process.env.VUE_APP_API_URL + vm.url + '/' + vm.id
                }
            }

            let buttons = []


            if( vm.action === 'edit' ){
                buttons.push( button_cancel)
                buttons.push( button_update)
            } else if( vm.action === 'show' ) {
                buttons.push( button_cancel )
                buttons.push( button_delete )
                buttons.push( button_edit )
            }
            else if ( vm.action === 'create' ) {
                buttons.push( button_cancel )
                buttons.push( button_save )
            } else {
                return
            }

            let settings = {
                width: 6,
                modal: false,
                tabs:[
                    {
                        name: '',
                        active: true,
                        sections: [
                            {
                                name: '',
                                width: 12,
                                inputs: [
                                    {
                                        name: 'skup_id',
                                        type: 'hidden',
                                        value: vm.skup_id,
                                        disabled: vm.disabled,
                                        config: {
                                            hidden:true
                                        }
                                    },
                                    {
                                        name: 'vrsta_sudionika_id',
                                        type: 'select',
                                        title: 'Vrste sudionika',
                                        value: vm.getVrstaSudionika( vm.data.vrsta_sudionika_id ),
                                        width: 12,
                                        error: vm.errors['vrsta_sudionika_id'] ? vm.errors['vrsta_sudionika_id'] : '',
                                        note: '',
                                        explanation: '',
                                        placeholder: '',
                                        required: !vm.disabled,
                                        readonly: vm.disabled,
                                        disabled: vm.disabled,
                                        config: {
                                            options: vm.vrsta_sudionika_select,
                                            multiple: false,
                                        }
                                    },
                                    {
                                        name: 'kotizacija_id',
                                        type: 'select',
                                        title: 'Kotizacija',
                                        value: vm.getKotizacija( vm.data.kotizacija_id ),
                                        width: 12,
                                        error: vm.errors['kotizacija_id'] ? vm.errors['kotizacija_id'] : '',
                                        note: '',
                                        explanation: '',
                                        placeholder: '',
                                        required: !vm.disabled,
                                        readonly: vm.disabled,
                                        disabled: vm.disabled,
                                        config: {
                                            options: vm.kotizacije_select,
                                            multiple: false,
                                        }
                                    },
                                    {
                                        name: 'cijena',
                                        type: 'input',
                                        title: 'Cijena',
                                        value: vm.data['cijena'] ? vm.data['cijena'] : '',
                                        width: 12,
                                        error: vm.errors['cijena'] ? vm.errors['cijena'] : '',
                                        note: '',
                                        explanation: '',
                                        placeholder: '',
                                        required: !vm.disabled || vm.action === 'edit',
                                        readonly: vm.disabled,
                                        disabled: vm.disabled,
                                    },
                                    {
                                        name: 'porez_id',
                                        type: 'select',
                                        title: 'Porez',
                                        value: vm.getPorez( vm.data.porez_id ),
                                        width: 12,
                                        error: vm.errors['porez_id'] ? vm.errors['porez_id'] : '',
                                        note: '',
                                        explanation: '',
                                        placeholder: '',
                                        required: !vm.disabled || vm.action === 'edit',
                                        readonly: vm.disabled,
                                        disabled: vm.disabled,
                                        config: {
                                            options: vm.porezi_select,
                                            multiple: false,
                                        }
                                    },
                                ],
                            }
                        ],
                    },
                ],
                buttons: buttons
            }

            vm.settings = settings
        },


        /**
         *  on input return data
         */
        onInput( name, value ){
            let vm = this
            if( vm.data[name] !== value ){
                vm.data[name] = value
                vm.setupForm()
            }
        },

        /**
         *  on button click
         */
        onFormButtonClick( id, action, config, data  ){

            if( id === 'save' || id === 'update' ){
                if( data.success){
                    if( id == 'save' )
                        toastr.success( 'Uspješno spremljeno!' )
                    else if ( id == 'update' )
                        toastr.success( 'Uspješno ažurirano!' )
                    this.$router.push({ path: this.route + '/' + data.data.id } )
                } else {
                    this.errors = data.messages
                    this.setupForm()
                }
            } else if( id == 'delete' ){
                toastr.error( 'Uspješno obrisano!' )
                this.$router.push({ path: this.route } )
            }

        },
    },

    mounted() {
        this.init()
    }
}
</script>

<style scoped>

</style>
